"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const addHex = obj => (acc, col) => {
  const color = obj[col];
  acc[col] = `#${color}`;
  return acc;
};

var _default = configObject => Object.keys(configObject).reduce(addHex(configObject), {});

exports.default = _default;